export enum DifficultyLevel {
  VERY_EASY = 'VERY_EASY',
  EASY = 'EASY',
  MEDIUM = 'MEDIUM',
  HARD = 'HARD',
  VERY_HARD = 'VERY_HARD',
  PRO = 'PRO',
  MASTER = 'MASTER',
  EXPERT = 'EXPERT',
  GENIUS = 'GENIUS',
  LEGEND = 'LEGEND',
}

export enum GameType {
  FRAGMENTS = 'fragments',
  METRO = 'metro',
}

export enum GameResult {
  WIN = 'WIN',
  LOSE = 'LOSE',
}

export enum UserType {
  SHORT = 'SHORT',
  STANDARD = 'STANDARD',
  FULL = 'FULL',
}
